import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { AiOutlineCheck, AiOutlineCloseCircle } from 'react-icons/ai';
import { clientState } from './utils/photon/client';
import { CHESS_HOME } from './config/links';
import './InviteOverlay.scss';


export const InviteOverlay = ({
  loggedInUser,
  joinMyInviteLink,
  showInviteModal,
  toggleInviteModal,
}) => {
  const [invitedUser, setInvitedUser] = useState('');
  const [matchDuration, setMatchDuration] = useState(15);
  const [copied, setCopied] = useState(false);
  const [matchInProgress, setShowMatchInProgress] = useState(clientState.playing);
  const [errorUsername, setErrorUsername] = useState(false);
  const [inviteLink, setInviteLink] = useState('');

  useEffect(() => {
    if (showInviteModal && inviteLink) navigator.clipboard.writeText(inviteLink);
    if (!clientState.playing) setShowMatchInProgress(false);
  }, [showInviteModal, inviteLink]);

  const handleGenerate = () => {
    if (!invitedUser) {
      setErrorUsername(true);
      return;
    }
    // TODO: validate username/address for the chains we support
    setErrorUsername(false);
    const inviteLink = `${CHESS_HOME}?time=${matchDuration}&player1=${loggedInUser}&player2=${invitedUser}`;
    setInviteLink(inviteLink);
    setCopied(true);
  };

  const handleNewLink = () => {
    setShowMatchInProgress(false);
    setCopied(false);
    setInviteLink('');
  };

  const handleJoinGeneratedMatch = () => {
    if (clientState.playing) {
      setShowMatchInProgress(true);
      return;
    }
    toggleInviteModal(); // Close the modal
    joinMyInviteLink({ invitePlayers: { player1: loggedInUser, player2: invitedUser } });
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      toggleInviteModal();
    }
  };

  return (
    <div
      className={`modal-overlay ${showInviteModal ? 'visible' : 'hidden'}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-content">
        <button className="close-modal icon" onClick={toggleInviteModal}>
          <FaTimes />
        </button>
        <h2 className="modal-title">Invite Friend</h2>

        {!copied ? (
          <>
            <div className="invite-fields">
              <input
                type="text"
                value={invitedUser}
                onChange={(e) => setInvitedUser(e.target.value)}
                placeholder={`Enter username/address`}
                className={`sci-fi-input${errorUsername ? ' error' : ''}`}
              />
              <div className="dropdown-button-group">
                <select
                  value={matchDuration}
                  onChange={(e) => setMatchDuration(Number(e.target.value))}
                  className="sci-fi-dropdown"
                >
                  {[5, 10, 15, 20, 25, 30].map((duration) => (
                    <option key={duration} value={duration}>
                      {duration} minutes
                    </option>
                  ))}
                </select>
                <button className="sci-fi-button" onClick={handleGenerate}>
                  Create Invite Link
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="invite-outcome">
            <div className="left-section">
              {matchInProgress ? (
                <>
                  <AiOutlineCloseCircle className="error-icon" />
                  <span className="finish-first-warning">Finish your match first</span>
                </>
              ) : (
                <>
                  <AiOutlineCheck className="checkmark" />
                  <span className="copied">Copied to clipboard</span>
                  <button className="sci-fi-button join-btn" onClick={handleJoinGeneratedMatch}>
                    Join
                  </button>
                </>
              )}
            </div>
            <div className="right-section">
              <button className="sci-fi-button new-invite-btn" onClick={handleNewLink}>
                New <span className="hide-desktop">Invite</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
